import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { adminAuthApi, type LoginRequest } from '../api/auth'
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../api/http'

interface Administrator {
  id: string
  username: string
  displayName: string
}

const ADMIN_KEY = 'alarm-admin-profile'

function readAdministrator(): Administrator | null {
  const raw = localStorage.getItem(ADMIN_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw) as Administrator
  } catch {
    localStorage.removeItem(ADMIN_KEY)
    return null
  }
}

export const useAuthStore = defineStore('auth', () => {
  const accessToken = ref(localStorage.getItem(ACCESS_TOKEN_KEY))
  const administrator = ref<Administrator | null>(readAdministrator())
  const isAuthenticated = computed(() => Boolean(accessToken.value))

  async function login(payload: LoginRequest) {
    const result = await adminAuthApi.login(payload)
    accessToken.value = result.accessToken
    administrator.value = result.administrator
    localStorage.setItem(ACCESS_TOKEN_KEY, result.accessToken)
    localStorage.setItem(REFRESH_TOKEN_KEY, result.refreshToken)
    localStorage.setItem(ADMIN_KEY, JSON.stringify(result.administrator))
  }

  function logout() {
    accessToken.value = null
    administrator.value = null
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
    localStorage.removeItem(ADMIN_KEY)
  }

  return {
    accessToken,
    administrator,
    isAuthenticated,
    login,
    logout,
  }
})
